import { useWa } from "@/lib/content";
import { useContent, rich } from "@/lib/content";
import { scrollToId } from "@/lib/smooth";
import { Reveal, WhatsIcon } from "./Primitives";
import { LogoSvg } from "./LogoSvg";

export const Footer = () => {
  const { BRANCHES, NAV, TEXTS: T } = useContent();
  const waLink = useWa();
  return (
  <footer data-testid="footer" className="relative overflow-hidden border-t border-gold/15 pt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <Reveal className="grid gap-10 border-b border-gold/15 pb-16 lg:grid-cols-2 lg:items-end">
        <h2 className="font-display text-5xl leading-[0.95] text-cream md:text-7xl">
          {rich(T.foot_cta)}
        </h2>
        <div className="lg:justify-self-end">
          <a
            data-testid="footer-whatsapp-cta"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 rounded-full bg-[#25D366] px-8 py-5 font-sans text-base font-semibold text-espresso transition-transform hover:-translate-y-1"
          >
            <WhatsIcon className="h-5 w-5" /> {T.btn_foot_wa}
          </a>
        </div>
      </Reveal>
      <div className="grid gap-12 py-16 md:grid-cols-3">
        <div>
          <LogoSvg part="logo-full" role="img" aria-label="Café Amadeus, desde 1986" data-testid="footer-logo" className="h-32 w-auto text-gold" />
          <p className="mt-5 max-w-xs font-sans text-sm leading-relaxed text-sand">{T.foot_about}</p>
        </div>
        <div>
          <p className="mb-4 font-sans text-xs uppercase tracking-[0.3em] text-gold">Navegación</p>
          <ul className="grid grid-cols-2 gap-2">
            {NAV.map((n) => (
              <li key={n.id}>
                <button data-testid={`footer-link-${n.id}`} onClick={() => scrollToId(n.id)} className="font-sans text-sm text-sand hover:text-cream">{n.label}</button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-4 font-sans text-xs uppercase tracking-[0.3em] text-gold">Teléfonos</p>
          <ul className="space-y-2">
            {BRANCHES.map((b) => (
              <li key={b.key} className="flex justify-between gap-4 font-sans text-sm text-sand">
                <span>{b.name}</span>
                <a href={`tel:+52${b.tel.replace(/\./g, "")}`} className="text-cream hover:text-gold">{b.tel}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="flex flex-col justify-between gap-3 border-t border-gold/15 py-8 font-sans text-xs text-sand md:flex-row">
        <span>© {new Date().getFullYear()} Café Amadeus. Todos los derechos reservados.</span>
        <span>Querétaro, México · Seit 1986</span>
      </div>
    </div>
    <div aria-hidden="true" className="pointer-events-none select-none px-[4vw] pb-4 text-gold/[0.07]"><LogoSvg part="amadeus" className="mx-auto h-auto w-full" /></div>
  </footer>
  );
};
